import React, { useState } from 'react';
import {  Route, Redirect   } from 'react-router-dom';
import {
  Box, Button, Container, Grid, Link, TextField,
  Typography, makeStyles
} from '@material-ui/core';

import { Alert, AlertTitle } from '@material-ui/lab';
import { createMuiTheme, ThemeProvider } from "@material-ui/core"; 
import {LoginLoadingSpinnerComponent} from '../Auth/Common/LoginLoader';
import {trackPromise} from 'react-promise-tracker';
import services from './services';


const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#00796B"
    },
    secondary: {
      main: "#607D8B"
    }
  }
})


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  loginButton: {
    backgroundColor: "#009688"
  }
}));

const Login = () => { 
 
  const classes = useStyles(); 
  const [userDetails, setUserDetails] = useState({
    username: "",
    password: ""

  });
  const [isHidden, setIsHidden] = useState(false)

  const [messageModel, setmessageModel] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

 async function login(e) {
    e.preventDefault();

    if (isSubmitting) return;

    setIsHidden(false);
    setIsSubmitting(true);

    try {
      const result = await trackPromise(services.login(userDetails));

      if (result.statusCode === 'Error') {
        setIsHidden(true);
        setmessageModel(result.message);
        setIsSubmitting(false);
        return;
      }

      sessionStorage.setItem('token', result.data);

      window.location.reload();
    } catch (error) {
      setIsHidden(true);
      setmessageModel('Unable to sign in. Please try again.');
      setIsSubmitting(false);
    }
  }
      
 

  function handleChange(e) {
    const target = e.target
    const value = target.name === 'isActive' ? target.checked : target.value 
    setUserDetails({
        ...userDetails,
        [e.target.name]: value
    }) 
}

  return (
    <ThemeProvider theme={theme}>
      {isSubmitting ? (
        <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        width="100vw"
      >
        <LoginLoadingSpinnerComponent />
      </Box>
      ) : (
      <Box display="flex"
        flexDirection="column"
        height="90%"
        justifyContent="center" >
        <Container maxWidth="sm"> 
          <form onSubmit={login}>
          <LoginLoadingSpinnerComponent />
            <Box mb={3}>
              <Typography
                color="textPrimary"
                variant="h2"
              >
                Sign in
              </Typography>
            </Box>
            <Grid item xs={12} md={12} >
              {isHidden ? <Alert severity="error">
                <AlertTitle>Error: <strong>{messageModel}</strong></AlertTitle>

              </Alert> : null}
            </Grid>
            <TextField
              className={classes.textField} 
              fullWidth 
              label="Username"
              margin="normal"
              name="username" 
              onChange={(e) => handleChange(e)}
              type="text"
              value={userDetails.username}
              variant="outlined"
            />
            <TextField 
              fullWidth 
              label="Password"
              margin="normal"
              name="password" 
              onChange={(e) => handleChange(e)}
              type="password"
              value={userDetails.password}
              variant="outlined"
            />
            <Box my={2}>
              <Button 
                color='primary' 
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                //onClick={(e) =>login(e)}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Signing in...' : 'Sign in now'}
              </Button>
            </Box>
          </form>
        </Container>
      </Box> )}
      
    </ThemeProvider>
  );
};

export default Login;
